import * as _ from "lodash";

import { DataSeries } from "./flotmodel";
import { MetaData } from "./MetaData";

export function allData(metaData: MetaData) {
  if (metaData) {
    return metaData.allData;
  }
  return [];
}

export function mergeSeries(dataSeries: DataSeries[]) {
  let chartData: any[] = [];
  if (dataSeries) {
    chartData = _.flatMap(dataSeries, series => {
      if (series.data) {
        return series.data.map(x => ({ time: x[0], [series.tagId]: x[1] }));
      }
      return [];
    });
  }
  chartData = _.flatMap(_.values(_.groupBy(chartData, "time")), x =>
    Object.assign({}, ...x)
  );
  // TODO Alternative: group by value first, then sort => each tag has its own series (see data attribute)
  return chartData;
}
